export enum TextboxEventType {
  TextboxDeleted = 'textboxDeleted',
  TextboxModified = 'textboxModified',
  TextboxCreated = 'textboxCreated',
  ReadyTextboxDraw = 'readyTextboxDraw',
}
